exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Process-module__wrapper___2C5Qp{display:grid;grid-template-rows:200px 1fr;position:relative}.Process-module__activity___ylOQY{box-shadow:0 0 17.5px rgba(0,0,0,.08);border-radius:22px;padding:1rem;background-color:#fff}.Process-module__activity___ylOQY,.Process-module__add-switch___1GaO1{height:-moz-max-content;height:max-content}.Process-module__add-switch___1GaO1{position:relative;top:96px}.Process-module__add-switch___1GaO1.Process-module__last-of-group___8W7s-{top:119px;position:absolute;right:-16px}", ""]);

// exports
exports.locals = {
	"wrapper": "Process-module__wrapper___2C5Qp",
	"activity": "Process-module__activity___ylOQY",
	"add-switch": "Process-module__add-switch___1GaO1",
	"last-of-group": "Process-module__last-of-group___8W7s-"
};